import { ShiftHours } from '@bemlo/enums'
import { arrayOfAll } from '@bemlo/utils'

import { Flex, IconName, MultiSelect } from '../../../elements'
import { useTranslations } from '../../../translate'
import { Detail } from '../components/Detail'
import { useCandidateView } from '../hooks/useCandidateView'
import { scopes } from '../scopes'

const SHIFT_HOURS = arrayOfAll<ShiftHours>()([
  ShiftHours.DAY,
  ShiftHours.EVENING,
  ShiftHours.NIGHT,
  ShiftHours.LONG,
])

export const Shifts = () => {
  const t = useTranslations()
  const { actor, data, isEditing, patchEditData } = useCandidateView()
  const { contract } = data

  const scope = scopes.contract()

  if (!actor.can('read', scope) || !contract) {
    return null
  }

  const label = t.candidate_view.contract.shift_hours()
  const icon: IconName = 'EveningIcon'

  if (isEditing(scope)) {
    return (
      <Flex gap={3} wrap>
        <MultiSelect
          label={label}
          labelIcon={icon}
          onChange={(allowedShiftHours) =>
            patchEditData({ contract: { ...contract, allowedShiftHours } })
          }
          options={SHIFT_HOURS.map((value) => ({
            label: t.$shiftHours(value),
            value,
            key: value,
          }))}
          value={contract.allowedShiftHours}
        />
      </Flex>
    )
  }

  const content = contract.allowedShiftHours.map(t.$shiftHours).join(', ')

  return <Detail content={content} heading={label} icon={icon} />
}
